import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Tabs, Button, Tooltip, DatePicker, Input, notification } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import moment from "moment";
import { useLocation } from "react-router-dom";
import filterSearch from "../../../../../utils/filterSearch";
import { useNavigate } from "react-router-dom";
import PremiumBlockInventories from "./PremiumBlockInventories";
import { useSelector } from "react-redux";
import discountCalc from "../../../../../utils/discountCalc";
import { useMediaQuery } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { getInventories } from "../../../../toolkit/slices/inventories/inventorySlice";
import { resetCart } from "../../../../toolkit/slices/cart/cartSlice";
import { combineSlices } from "@reduxjs/toolkit";
import BdfExcelImportModal from "../../../components/BdfExcelImportModal";
import useBdfExcelImport from "../../BDFCreatorContainer/useBdfExcelImport";

dayjs.extend(utc);

// Premium block imports only need the inventory and its period.
const PREMIUM_IMPORT_COLUMNS = ["codeNo", "startDate", "endDate"];

// Same line the "Add inventories" picker builds for a premium block.
const mapInvForPremiumImport = (ele) => ({
  _id: ele._id,
  codeNo: ele.CodeNo,
  location: ele?.locations?.name,
  width: ele.width,
  height: ele.height,
  Bookings: ele.Bookings,
  rpm: ele.ratePerMonth,
  Illu: ele.Illu,
  unit: ele?.unit || 1,
  isOverlapPossible: ele?.isOverlapPossible,
  specialRatePerMonth: ele.ratePerMonth,
  ratePerMonth: ele.ratePerMonth,
  checked: false,
});

const ALWAYS_CAN_ADD = () => ({ canAdd: true, reason: "" });

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const PremiumBlockForm = ({ mode }) => {
  //Chose prop Drilling for a Reason 🤡🤡🤡🤡 | Will be using Context for another components

  const inputRef = useRef(null);
  const location = useLocation();
  let reduxInvs = useSelector((state) => state.inventoriesList.inventories);
  let userData = useSelector((state) => state?.user);
  const dispatch = useDispatch();
  const [openInvs, setOpenInvs] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [allInv, setAllInv] = useState(null);
  const [allInvD, setAllInvD] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [premiumId, setPremiumId] = useState(null);
  const [clientNames, setClientNames] = useState(null);
  const [premiumData, setPremiumData] = useState({
    inventories: null,
    blockedForId: null,
    blockedForName: null,
    packageRate: null,
    isPackageRateEnabled: false,
    confirmedBy: null,
    campaignName: null,
  });
  const isMobile = useMediaQuery("(max-width:769px)");
  const {
    blockedForId,
    blockedForName,
    inventories,
    confirmedBy,
    campaignName: reduxCampaignName,
    fromBdf,
    bdfId: reduxBdfId,
  } = useSelector((state) => state.blockedInventory.data || {});
  const bdfIdFromConvert =
    location?.state?.bdfId || reduxBdfId || null;
  const isFromBdfConvert = Boolean(fromBdf || bdfIdFromConvert);

  // Sync local state with Redux state
  useEffect(() => {
    if (mode == "create") {
      setPremiumData((prev) => ({
        ...prev,
        inventories,
        blockedForId,
        blockedForName,
        confirmedBy,
        campaignName: reduxCampaignName ?? prev.campaignName,
        // From BDF: amounts are cleared — package mode skips rate validation
        ...(isFromBdfConvert
          ? { isPackageRateEnabled: true, packageRate: null }
          : {}),
      }));
    }
  }, [
    blockedForId,
    blockedForName,
    inventories,
    confirmedBy,
    reduxCampaignName,
    isFromBdfConvert,
    mode,
  ]);
  useEffect(() => {
    if (premiumData?.isPackageRateEnabled) {
      setPremiumData((prev) => {
        if (!Array.isArray(prev?.inventories)) return prev;
        let data = prev.inventories.map((ele) => {
          return {
            ...ele,
            specialRatePerMonth: 0,
            specialRate: 0,
          };
        });
        return {
          ...prev,
          inventories: data,
        };
      });
    }
  }, [premiumData?.isPackageRateEnabled]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await fetch(
          `${apiBaseUrl}/inventoryManagement/displayPartyCompanies`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        let responseJson = await response.json();
        let options = responseJson?.data.map((ele) => ({
          label: ele.name,
          value: ele._id,
        }));
        console.log(options);
        setClientNames(options);
      } catch (err) {
        console.error(`Error: ${err.message}`);
      }
    };
    fetchData();
  }, [apiBaseUrl]);
  useEffect(() => {
    const filteredInventories = reduxInvs.filter(
      (itemB) =>
        !premiumData?.inventories?.some((itemA) => itemA?._id === itemB._id)
    );
    const muchFilteredData = filteredInventories.map((ele) => {
      return {
        _id: ele._id,
        codeNo: ele.CodeNo,
        location: ele.locations.name,
        width: ele.width,
        height: ele.height,
        Bookings: ele.Bookings,
        rpm: ele.ratePerMonth,
        Illu: ele.Illu,
        unit: ele?.unit || 1,
        isOverlapPossible: ele?.isOverlapPossible,
        specialRatePerMonth: ele.ratePerMonth,
        ratePerMonth: ele.ratePerMonth,
        checked: false,
      };
    });
    // console.log("🎂🎂🎂", muchFilteredData);
    setAllInv(muchFilteredData);
    setAllInvD(muchFilteredData);
  }, [reduxInvs, premiumData?.inventories]);

  useEffect(() => {
    if ((mode = "edit")) {
      let linkSplit = window.location.href.split("/");
      let id = linkSplit[linkSplit.length - 1];
      fetchPremimDataById(id);
    }
  }, [mode]);

  async function fetchPremimDataById(id) {
    try {
      const cleanId = id.split("?")[0];

      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/premiumBlockById?id=${cleanId}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      let responseJson = await response.json();
      const data = responseJson?.data || {};
      setPremiumData((prev) => {
        return {
          ...prev,
          ...data,
          campaignName: data.campaignName ?? prev.campaignName,
          confirmedBy: data.confirmedBy ?? prev.confirmedBy,
          isPackageRateEnabled: data.packageRate ? true : false,
        };
      });
      setPremiumId(cleanId);
    } catch (error) {
      console.error(`Error: ${error.message}`);
    }
  }
  function displayInvs() {
    dispatch(getInventories());
    setToggle((prev) => !prev);
    setOpenInvs(true);
  }
  let debounceTimer;
  const handleFilterData = (e) => {
    clearTimeout(debounceTimer);
    setSearchText(e.target.value);
    debounceTimer = setTimeout(() => {
      setAllInv(filterSearch(e.target.value, allInvD));
    }, 500); // Adjust the debounce time as needed (e.g., 300 milliseconds)
  };
  const handleOkOfAllInv = () => {
    let data;
    if (premiumData?.packageRate) {
      data = allInv
        .filter((ele) => ele.checked)
        .map((ele) => ({
          ...ele, // Spread the existing properties
          specialRatePerMonth: 0,
          specialRate: 0,
        }));
    } else {
      data = allInv.filter((ele) => ele.checked);
    }
    setOpenInvs(false);
    let existingData = premiumData?.inventories;
    setPremiumData((prev) => {
      return {
        ...prev,
        inventories: [...data, ...existingData],
      };
    });
  };
  const handleCloseAllInv = () => {
    setOpenInvs(false);
    setAllInv(null);
    setAllInvD(null);
    setSearchText("");
  };
  const handleCheckboxChange = (e, record) => {
    const { checked } = e.target;
    const updatedData = allInvD.map((item) => {
      if (item._id === record._id) {
        return { ...item, checked };
      }
      return item;
    });
    setAllInv(updatedData);
    setAllInvD(updatedData);
  };
  const navigate = useNavigate();
  let { id } = useParams();
  const onChange = (key) => {
    setActiveTab(key);
  };
  const items = [{ key: "1", label: "Premium Block" }];
  const renderTabContent = () => {
    switch (activeTab) {
      case "1":
        return (
          <PremiumBlockInventories
            handleDateRangeChange={handleDateRangeChange}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
            isMobile={isMobile}
            discountCalc={discountCalc}
            premiumData={premiumData}
            isDateBlocked={isDateBlocked}
            reduxInvs={reduxInvs}
            handlePackageRateChange={handlePackageRateChange}
            handleSwitchChange={handleSwitchChange}
            handleCloseAllInv={handleCloseAllInv}
            handleOkOfAllInv={handleOkOfAllInv}
            openInvs={openInvs}
            inputRef={inputRef}
            searchText={searchText}
            handleFilterData={handleFilterData}
            handleCheckboxChange={handleCheckboxChange}
            allInv={allInv}
            clientNames={clientNames}
            handleEditPremiumData={handleEditPremiumData}
          />
        );
      default:
        return null;
    }
  };

  const handleEdit = (value, id, field) => {
    setPremiumData((prev) => {
      const index = prev?.inventories?.findIndex((item) => item._id === id);
      if (index === -1) return prev; // Handle case where ID is not found

      // Clone the inventories to avoid mutating state directly
      const updatedInventories = [...prev.inventories];
      const inventory = updatedInventories[index];
      const updatedInventory = { ...inventory };

      // Update the specific field
      if (field === "specialRatePerMonth") {
        updatedInventory[field] = Number(value);
        if (inventory.startDate && inventory.endDate) {
          const { newSpecialRate, discount } = MonthToDurationRate(
            updatedInventory,
            inventory.startDate,
            inventory.endDate
          );
          updatedInventory.specialRate = newSpecialRate || 0;
          updatedInventory.discount = discount;
        }
      } else {
        updatedInventory[field] = Number(value);
      }

      // Update the inventory in the list
      updatedInventories[index] = updatedInventory;

      // Return the updated state
      return {
        ...prev,
        inventories: updatedInventories,
      };
    });
  };
  const handleEditPremiumData = (value, field) => {
    setPremiumData((prev) => {
      return {
        ...prev,
        [field]: value,
      };
    });
  };
  function handleDelete(id) {
    if (premiumData?.inventories.length == 1) {
      notification.error({ message: "Cant Keep the Inventory List Empty!" });
    } else {
      setPremiumData((prev) => {
        let filteredData = prev?.inventories?.filter((ele) => ele._id !== id);
        return {
          ...prev,
          inventories: filteredData,
        };
      });
      notification.success({ message: "Inventory Removed!" });
    }
  }
  const handleDateRangeChange = (dates, dateStrings, recordId) => {
    if (!dateStrings || dateStrings.length !== 2) {
      console.error("Invalid date range selected");
      return; // Exit if dates are invalid
    }

    const [startDate, endDate] = dateStrings;

    setPremiumData((prev) => {
      // Clone the current state
      const updatedInventories = [...prev.inventories];

      // Find the inventory item by ID
      const index = updatedInventories.findIndex(
        (item) => item._id === recordId
      );
      if (index === -1) return prev; // Handle case where ID is not found

      const inventory = updatedInventories[index];

      // Calculate the new special rate and discount
      let { newSpecialRate, discount } = MonthToDurationRate(
        inventory,
        startDate,
        endDate
      );

      // Update the specific inventory item
      updatedInventories[index] = {
        ...inventory,
        startDate,
        endDate,
        specialRate: newSpecialRate || 0,
        discount,
      };

      // Return updated state
      return {
        ...prev,
        inventories: updatedInventories,
      };
    });
  };

  const MonthToDurationRate = (ele, startDateStr, endDateStr) => {
    // startDate = new Date(startDate);
    // endDate = new Date(endDate);

    const startDate = dayjs(startDateStr, "DD-MM-YYYY").toDate();
    const endDate = dayjs(endDateStr, "DD-MM-YYYY").toDate();

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error("Invalid start or end date passed to MonthToDurationRate");
      return { newSpecialRate: 0, discount: 0 };
    }

    const startYear = startDate.getFullYear();
    const startMonth = startDate.getMonth();
    const startDay = startDate.getDate();
    const endYear = endDate.getFullYear();
    const endMonth = endDate.getMonth();
    const endDay = endDate.getDate();

    let fullMonths = 0;
    let remainingDays = 0;

    const isStartFullMonth = startDay === 1;
    const isEndFullMonth =
      endDay === new Date(endYear, endMonth + 1, 0).getDate();

    if (isStartFullMonth && isEndFullMonth) {
      // Case 1: Full months
      fullMonths = (endYear - startYear) * 12 + (endMonth - startMonth) + 1;
    } else {
      fullMonths = (endYear - startYear) * 12 + (endMonth - startMonth);

      if (!isStartFullMonth) {
        fullMonths -= 1;
        remainingDays +=
          new Date(startYear, startMonth + 1, 0).getDate() - startDay + 1; // Days remaining in the start month
      }

      if (!isEndFullMonth) {
        remainingDays += endDay;
      }

      if (startYear === endYear && startMonth === endMonth) {
        remainingDays = endDay - startDay + 1;
        fullMonths = 0;
      }
    }

    if (remainingDays >= 30) {
      fullMonths += Math.floor(remainingDays / 30);
      remainingDays %= 30;
    }

    const daysInStartMonth = (() => {
      const days = new Date(startYear, startMonth + 1, 0).getDate();
      return days === 28 || days === 29 ? 30 : days;
    })();
    const dailyRate = ele?.specialRatePerMonth / daysInStartMonth;
    const totalCost =
      fullMonths * ele?.specialRatePerMonth + remainingDays * dailyRate;
    const perDayRpm = ele?.rpm / daysInStartMonth;
    const srPerDay = ele?.specialRatePerMonth / daysInStartMonth;

    let newSpecialRate = Number(totalCost.toFixed(2));
    const discount = Math.floor(Number(100 - (srPerDay * 100) / perDayRpm));
    const differenceInMilliseconds = endDate - startDate;
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    if (
      differenceInDays == 27 ||
      differenceInDays == 28 ||
      differenceInDays == 29 ||
      differenceInDays == 30 ||
      differenceInDays == 31
    ) {
      newSpecialRate = ele?.specialRatePerMonth;
    }
    return { newSpecialRate: Math.floor(newSpecialRate), discount };
  };

  const isDateBlocked = (
    currentDate,
    bookings,
    blockedDates,
    premiumBlock,
    record,
  ) => {
    // Check if currentDate is provided
    if (!currentDate) return false;

    // Allow overlapping dates for inventories where overlap is explicitly allowed
    if (record?.isOverlapPossible) return false;

    // Format the current date
    const dateString = currentDate.format("YYYY-MM-DD");

    // Check if the date is within the booking ranges
    const isBookingBlocked = bookings?.some(({ startDate, endDate }) => {
      const start = moment(startDate).format("YYYY-MM-DD");
      const end = moment(endDate).format("YYYY-MM-DD");
      return dateString >= start && dateString <= end;
    });

    // Any blocked-dates doc with a range (not only premium / management)
    const isBlockedByInventoryBlock = blockedDates?.some((block) => {
      if (
        !block?.blockedAt ||
        !block?.blockedTill ||
        block.archived === true
      ) {
        return false;
      }
      const start = moment(block.blockedAt).format("YYYY-MM-DD");
      const end = moment(block.blockedTill).format("YYYY-MM-DD");
      return dateString >= start && dateString <= end;
    });

    let isFullBlocked;
    if (record.fullId) {
      isFullBlocked = record?.fullId?.Bookings?.some(
        ({ startDate, endDate }) => {
          const start = moment(startDate).format("YYYY-MM-DD");
          const end = moment(endDate).format("YYYY-MM-DD");
          return dateString >= start && dateString <= end;
        },
      );
    }
    let isHalf1Blocked;
    if (record.half1Id) {
      isHalf1Blocked = record?.half1Id?.Bookings?.some(
        ({ startDate, endDate }) => {
          const start = moment(startDate).format("YYYY-MM-DD");
          const end = moment(endDate).format("YYYY-MM-DD");
          return dateString >= start && dateString <= end;
        },
      );
    }
    let isHalf2Blocked;
    if (record.half2Id) {
      isHalf2Blocked = record?.half2Id?.Bookings?.some(
        ({ startDate, endDate }) => {
          const start = moment(startDate).format("YYYY-MM-DD");
          const end = moment(endDate).format("YYYY-MM-DD");
          return dateString >= start && dateString <= end;
        },
      );
    }

    //Check if the date is within the premiumBlock ranges
    const isPremiumBlocked = premiumBlock?.some(({ startDate, endDate }) => {
      const start = moment(startDate).format("YYYY-MM-DD");
      const end = moment(endDate).format("YYYY-MM-DD");
      return dateString >= start && dateString <= end;
    });

    // Block the date if it falls within any range
    return (
      isBookingBlocked ||
      isBlockedByInventoryBlock ||
      isPremiumBlocked ||
      isFullBlocked ||
      isHalf1Blocked ||
      isHalf2Blocked
    );
  };
  function validateAndNotify(data) {
    let isValid = true;

    if (!data.campaignName) {
      notification.error({
        message: "Validation Error",
        description: "Field 'Campaign name' is required.",
      });
      return false;
    }

    if (!data.confirmedBy) {
      notification.error({
        message: "Validation Error",
        description: "Field 'Confirmed By' is required.",
      });
      return false;
    }

    if (!data.blockedForId && !data.blockedForName) {
      notification.error({
        message: "Validation Error",
        description: "Choose a client to block inventory for.",
      });
      return false;
    }

    if (Array.isArray(data.inventories) && data.inventories.length === 0) {
      notification.error({
        message: "Validation Error",
        description: "Add at least one inventory (or upload an Excel).",
      });
      return false;
    }

    if (Array.isArray(data.inventories)) {
      // BDF → Premium: amounts are intentionally zero / hidden — skip rate checks
      const skipRateValidation =
        Boolean(isFromBdfConvert) || Boolean(data.isPackageRateEnabled);

      for (let index = 0; index < data.inventories.length; index++) {
        const inventory = data.inventories[index];

        if (
          !skipRateValidation &&
          (inventory.specialRatePerMonth == null ||
            inventory.specialRatePerMonth === "")
        ) {
          notification.error({
            message: `Inventory Validation Error`,
            description: `Field 'Special Rate Per Month' is missing in ${data?.inventories[index]?.location}`,
          });
          return false; // Stop further checks
        }
        if (!inventory.startDate) {
          notification.error({
            message: `Inventory Validation Error`,
            description: `Field 'startDate' is missing in  ${data?.inventories[index]?.location}`,
          });
          return false; // Stop further checks
        }

        if (!inventory.endDate) {
          notification.error({
            message: `Inventory Validation Error`,
            description: `Field 'endDate' is missing in  ${data?.inventories[index]?.location}`,
          });
          return false; // Stop further checks
        }
        if (
          !skipRateValidation &&
          (inventory.specialRate == null || inventory.specialRate === "")
        ) {
          notification.error({
            message: `Inventory Validation Error`,
            description: `Field 'Special Rate' is missing in  ${data?.inventories[index]?.location}`,
          });
          return false; // Stop further checks
        }
      }
    } else {
      notification.error({
        message: "Validation Error",
        description: "Inventories field is not an array.",
      });
      return false; // Stop further checks
    }

    return isValid; // Return true if all validations pass
  }

  const sanitizePremiumInventories = (inventories) => {
    const getValidUTCDate = (dateStr) => {
      if (!dateStr) return null;

      let parsed = dayjs.utc(dateStr, "DD-MM-YYYY", true);
      if (!parsed.isValid()) {
        parsed = dayjs.utc(dateStr); // fallback for ISO or other valid formats
      }

      return parsed.isValid() ? parsed.startOf("day").toISOString() : null;
    };

    return inventories.map(({ excelDates, ...item }) => {
      return {
        ...item,
        startDate: getValidUTCDate(item.startDate),
        endDate: getValidUTCDate(item.endDate),
      };
    });
  };

  const handleBlockSubmission = async () => {
    try {
      let flag = validateAndNotify(premiumData);

      if (!flag) return;
      let body = {
        parentCompanyId: premiumData?.blockedForId,
        parentCompanyName: premiumData?.blockedForName,
        inventories: sanitizePremiumInventories(premiumData?.inventories || []),
        packageRate: premiumData?.packageRate,
        blockedBy: userData?._id,
        confirmedBy: premiumData?.confirmedBy,
        campaignName: premiumData?.campaignName
          ? premiumData?.campaignName?.trim().toUpperCase()
          : premiumData?.campaignName,
        // When converting from BDF, backend archives the source BDF after create
        ...(bdfIdFromConvert ? { bdfId: bdfIdFromConvert } : {}),
      };

      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/createPremiumBlock`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );
      let responseJson = await response.json();
      if (responseJson.success) {
        notification.success({
          message:
            responseJson.message ||
            (bdfIdFromConvert
              ? "Premium Block created successfully. The BDF has been archived."
              : "Premium Block Created!"),
        });
        dispatch(resetCart());
        navigate("/premiumBlockList?tab=1"); // confirmed bookings
      } else {
        notification.error({ message: responseJson.message });
      }
    } catch (err) {
      return console.error("Error: ", err.message);
    }
  };
  const handleEditPremiumSubmission = async () => {
    try {
      let flag = validateAndNotify(premiumData);
      if (!flag) return;
      let body = {
        id: premiumId,
        parentCompanyId: premiumData?.blockedForId,
        inventories: sanitizePremiumInventories(premiumData?.inventories || []),
        packageRate: premiumData?.packageRate,
        blockedBy: userData?._id,
        confirmedBy: premiumData?.confirmedBy,
        campaignName: premiumData?.campaignName
          ? premiumData?.campaignName?.trim().toUpperCase()
          : premiumData?.campaignName,
      };
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/editPremiumBlock`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );
      let responseJson = await response.json();
      if (responseJson.success) {
        notification.success({ message: "Premium Block Edited!" });
        // Check if "?onHold" exists in the current URL
        const searchParams = new URLSearchParams(location.search);
        const isOnHold = searchParams.has("onHold");

        // Navigate based on query param presence
        navigate(
          isOnHold ? "/premiumBlockList?tab=2" : "/premiumBlockList?tab=1"
        );
      } else {
        notification.error({ message: "Failed to edit premium block!" });
      }
    } catch (err) {
      return console.error("Error: ", err.message);
    }
  };
  const handleSwitchChange = (checked) => {
    setPremiumData((prev) => ({
      ...prev,
      isPackageRateEnabled: checked,
    }));
  };
  const handlePackageRateChange = (value) => {
    setPremiumData((prev) => ({
      ...prev,
      packageRate: Number(value), // Ensure packageRate is stored as a number
    }));
  };

  // ---- Import inventories from Excel (Code No + Start/End Date only) ----
  const {
    excelInputRef,
    excelImport,
    handleExcelFileChange,
    closeExcelImport,
    confirmExcelImport,
    downloadExcelTemplate,
    openExcelPicker,
    openExcelImport,
  } = useBdfExcelImport({
    inventories: premiumData?.inventories || [],
    setInventories: (updater) =>
      setPremiumData((prev) => ({
        ...prev,
        inventories: updater(Array.isArray(prev?.inventories) ? prev.inventories : []),
      })),
    allowDuplicateInventories: false,
    packageRate: premiumData?.packageRate,
    isDateBlocked,
    calcSpecialRate: MonthToDurationRate,
    canAddToCart: ALWAYS_CAN_ADD,
    columnKeys: PREMIUM_IMPORT_COLUMNS,
    chargesEnabled: false,
    mapInventory: mapInvForPremiumImport,
    createLine: (item) => item,
    includeRemovedAndTrading: false,
  });

  return (
    <div
      className="parent-padding-container"
      style={{
        backgroundColor: "white",
        padding: "0px 20px",
        borderRadius: "12px",
      }}
    >
      <div id="TabsAndBtn" style={{ padding: 0 }}>
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={onChange}
          items={items}
        />
        <div style={{ display: "flex", gap: "1rem" }}>
          {mode == "create" ? (
            <Button type="primary" onClick={() => handleBlockSubmission()}>
              Create Premium Block
            </Button>
          ) : (
            <Button
              type="primary"
              onClick={() => handleEditPremiumSubmission()}
            >
              Save
            </Button>
          )}
          <Button type="primary" onClick={() => displayInvs()}>
            Add inventories
          </Button>
          <Button type="primary" onClick={openExcelImport}>
            Upload Excel
          </Button>
          <input
            ref={excelInputRef}
            type="file"
            accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
            style={{ display: "none" }}
            onChange={handleExcelFileChange}
          />
        </div>
      </div>
      {renderTabContent()}
      <BdfExcelImportModal
        open={excelImport.open}
        status={excelImport.status}
        fileName={excelImport.fileName}
        error={excelImport.error}
        foundHeaders={excelImport.foundHeaders}
        info={excelImport.info}
        plan={excelImport.plan}
        packageRateActive={false}
        importing={false}
        onImport={confirmExcelImport}
        onCancel={closeExcelImport}
        onDownloadTemplate={downloadExcelTemplate}
        onChooseAnother={openExcelPicker}
        columnKeys={PREMIUM_IMPORT_COLUMNS}
      />
    </div>
  );
};

export default PremiumBlockForm;
